import { cn } from "@/lib/utils";

const STYLES = {
  NYTT: "bg-emerald-500/15 text-emerald-400 border-emerald-500/40",
  UPPDATERAT: "bg-amber-500/15 text-amber-400 border-amber-500/40",
  PRELIMINÄRT: "bg-sky-500/15 text-sky-400 border-sky-500/40",
  OFFICIELLT: "bg-purple-500/15 text-purple-400 border-purple-500/40",
};

export const StatusBadge = ({ status, className }) => {
  if (!status) return null;
  const style = STYLES[status] || "bg-white/10 text-white/70 border-white/20";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn("inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] font-mono font-semibold uppercase tracking-widest", style, className)}
    >
      {status}
    </span>
  );
};
